declare namespace $ {

	type $mol_button_minor__title_shm_projects_codex_chat_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_projects_codex_chat_2 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['sessions_unpin_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_projects_codex_chat_3 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['sessions_unpin'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_codex_chat_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_shm_projects_codex_chat_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_shm_projects_codex_chat_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_shm_projects_codex_chat_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_projects_codex_chat_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_labeler__title_shm_projects_codex_chat_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_projects_codex_chat_10 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['Sessions_memory_value'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_minor__title_shm_projects_codex_chat_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_codex_chat_12 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['codex_server_restart'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_projects_codex_prompt__hint_shm_projects_codex_chat_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_codex_prompt['hint'] >
	>
	type $shm_projects_codex_prompt__value_shm_projects_codex_chat_14 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['prompt'] >
		,
		ReturnType< $shm_projects_codex_prompt['value'] >
	>
	type $shm_projects_codex_prompt__event_shm_projects_codex_chat_15 = $mol_type_enforce<
		({ 
			paste( next?: ReturnType< $shm_projects_codex_chat['attachment_paste'] > ): ReturnType< $shm_projects_codex_chat['attachment_paste'] >,
		})  & ReturnType< $shm_projects_codex_prompt['event'] >
		,
		ReturnType< $shm_projects_codex_prompt['event'] >
	>
	type $shm_projects_codex_prompt__submit_shm_projects_codex_chat_16 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['steer'] >
		,
		ReturnType< $shm_projects_codex_prompt['submit'] >
	>
	type $shm_projects_codex_prompt__enter_submit_shm_projects_codex_chat_17 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_chat['send'] >
		,
		ReturnType< $shm_projects_codex_prompt['enter_submit'] >
	>
	export class $shm_projects_codex_chat extends $shm_hitalama_project_codex {
		Sessions_actions_icon( ): $mol_icon_dots_vertical
		sessions_unpin( next?: any ): any
		Unpin_all( ): $mol_button_minor
		codex_server_memory( ): string
		Sessions_memory_value( ): $mol_view
		codex_server_restart( next?: any ): any
		sessions_page_visible( ): boolean
		Sessions_actions( ): $mol_pick
		Sessions_memory( ): $mol_labeler
		Sessions_restart( ): $mol_button_minor
		Prompt( ): $shm_projects_codex_prompt
	}
	
	export class $shm_projects_codex extends $shm_projects_catalog {
		Codex( ): $shm_projects_codex_chat
	}
	
}

//# sourceMappingURL=codex.view.tree.d.ts.map